import { createSelector } from 'reselect';

import getPropFromModule from './getPropFromCitiesModule';
import { DATA } from '../model';

const getCities = createSelector(
  state => getPropFromModule(state, DATA),
  cities => cities.sortBy(x => x.get('name')).toJS(),
);

export default getCities;
